import { I18n } from '@aws-amplify/core';

import type { StrainIndexReport } from '@/types/StrainIndex';

const SAFE_RISK = 'SAFE';
const SAFE_DESCRIPTION = 'Job is probably safe';
const HAZARDOUS_DESCRIPTION = 'Job is probably hazardous';

export interface StrainIndexFactor {
	label: string;
	left: number;
	right: number;
}

export function toScoreText(value: number): string {
	const result = value.toLocaleString();

	return result;
}

export function toRiskDescription(risk: string): string {
	if (risk === SAFE_RISK) {
		const safe = I18n.get(SAFE_DESCRIPTION);

		return safe;
	}

	const hazardous = I18n.get(HAZARDOUS_DESCRIPTION);

	return hazardous;
}

export function buildStrainIndexFactors(strainIndex: StrainIndexReport): StrainIndexFactor[] {
	const result = [
		{
			label: I18n.get('Intensity of exertion'),
			left: strainIndex.score_left_borg_scale,
			right: strainIndex.score_right_borg_scale
		},
		{
			label: I18n.get('Efforts per minute'),
			left: strainIndex.score_left_efforts_per_minute,
			right: strainIndex.score_right_efforts_per_minute
		},
		{
			label: I18n.get('Duration per exertion'),
			left: strainIndex.score_left_exertion_duration,
			right: strainIndex.score_right_exertion_duration
		},
		{
			label: I18n.get('Hand/wrist posture'),
			left: strainIndex.score_left_wrist_posture,
			right: strainIndex.score_right_wrist_posture
		},
		{
			label: I18n.get('Duration of task per day'),
			left: strainIndex.score_left_daily_duration,
			right: strainIndex.score_right_daily_duration
		}
	];

	return result;
}
